import {
    EnumIsLike,
    EnumResolveResult,
    EnumServiceTypeReal,
    ScheduleType,
    EnumTeachAttitude,
    EnumIsLikeNew
} from '@types';

export const DEFAULT_AVATAR: string = 'https://simg01.gaodunwangxiao.com/uploadfiles/tmp/upload/202008/05/848a8_20200805163032.png';
export const REQ_SUCCESS: number = 0;//请求成功

export const CARE_TIMEOUT_UNHANDLED = 'CARE_TIMEOUT_UNHANDLED'; //超时未处理的问题
export const CARE_PRE_TIMEOUT_UNHANDLED = 'CARE_PRE_TIMEOUT_UNHANDLED'; //即将超时未处理的问题
export const CARE_UNASSIGNED = 'CARE_UNASSIGNED'; //未分配的问题
export const CARE_NEARLY_7_DAYS_BAD = 'CARE_NEARLY_7_DAYS_BAD'; //近7天差评的问题
export const CARE_NEARLY_7_DAYS_TIMEOUT_HANDLED = 'CARE_NEARLY_7_DAYS_TIMEOUT_HANDLED'; //近7天超时已处理的问题

export const QUESTION_UN_ASSIGNED = 0; //未分配
export const QUESTION_ANSWERED = 1; //已回答
export const QUESTION_UN_ANSWERED = 2; //未回答
export const QUESTION_ASKED_UN_ANSWERED = 3; //追问未回答
export const QUESTION_ASKED_UN_ASSIGNED = 4; //追问未分配
export const QUESTION_CLOSED = 6; //已关闭
export const QUESTION_UNHANDLED_GROUP = [QUESTION_UN_ASSIGNED, QUESTION_UN_ANSWERED, QUESTION_ASKED_UN_ANSWERED, QUESTION_ASKED_UN_ASSIGNED];
export const QUESTION_UN_ASSIGNED_GROUP = [QUESTION_UN_ASSIGNED, QUESTION_ASKED_UN_ASSIGNED];

export const QUESTION_SUB_STATUS_ALL = 0; //全部
export const QUESTION_TIMEOUT_WARNING = 1; //超时预警
export const QUESTION_TIMEOUT = 2; //超时
export const QUESTION_BAD_APPRAISE = 3; //差评问题
export const QUESTION_GOOD_APPRAISE = 4; //好评问题
export const QUESTION_UN_APPRAISE = 5; //未评价
export const QUESTION_PRE_TIMEOUT = 6; //即将超时 介于预警和超时范围内

export const QUESTION_TIME_SCOPE_ALL = 1; 				//1 全部
export const QUESTION_TIME_SCOPE_NEARLY_30_DAYS = 2; 	// 2 最近30天
export const QUESTION_TIME_SCOPE_RANGE = 3; 			// 3 时间段

export const appid = 180302;

export const CURRENT_POSITION = 'currentVideoPosition'; // 视频记录功能

export const PAGESIZEOPTIONS = ['20', '30', '50', '70', '100'];

/** 后台token */
export const TOKEN_ACCESS = 'accessAdmintoken';
/** 后台token */
export const TOKEN_REFRESH = 'refreshAdmintoken';
/** 前台学员用的token */
export const TOKEN_ACCESS_FRONT = 'accessToken';
/** 防止其他平台换账号，用户登出校验的 key */
export const GDUSERID = 'GDUSERID';
export const GTRS_GDUSERID = 'GTRS-GDUSERID';

export const IS_LIKE_MAP: { [key in number]: string } = {
    [EnumIsLike.greatSatisfaction]: '非常满意',
    [EnumIsLike.unSatisfaction]: '不满意',
    [EnumIsLike.satisfaction]: '满意',
    [EnumIsLike.bad]: '差评',
    [EnumIsLike.normal]: '一般',
};
export const IS_LIKE_MAP_NEW: { [key in number]: string } = {
    [EnumIsLikeNew.verygood]: '非常满意',
    [EnumIsLikeNew.great]: '满意',
    [EnumIsLikeNew.normal]: '一般',
    [EnumIsLikeNew.not]: '不满意',
    [EnumIsLikeNew.bad]: '非常不满意',
};

export const RESOLVE_RESULT_MAP: { [key in number]: string } = {
    [EnumResolveResult.unResolve]: '没解决',
    [EnumResolveResult.resolved]: '解决了',
    [EnumResolveResult.exceedExpect]: '超过预期'
};

export const TEACHER_ATTITUDE_MAP: { [key in number]: string } = {
    [EnumTeachAttitude.bad]: '不好',
    [EnumTeachAttitude.normal]: '一般',
    [EnumTeachAttitude.good]: '很赞'
};

export const SERVICE_TYPE_REAL: { [key in number]: string } = {
    [EnumServiceTypeReal.live]: '直播',
    [EnumServiceTypeReal.phone]: '电话',
    [EnumServiceTypeReal.report]: '报备'
};
export const SERVICE_TYPE: { [key in number]: string } = {
    [EnumServiceTypeReal.live]: '直播',
    [EnumServiceTypeReal.phone]: '电话',
    [EnumServiceTypeReal.face]: '面授'
};

export const SCHEDULE_STATUS: { [key in number]: string } = {
    [ScheduleType.idle]: '空闲',
    [ScheduleType.expired]: '已过期',
    [ScheduleType.reserved]: '已预约',
    [ScheduleType.end]: '已结束',
    [ScheduleType.occupied]: '已占用',
};

export const PERSONAN_SERVICE_COLUMNS_EDIT_LIST: any = [
    {
        title: '学员网校ID',
        require: true
    },
    {
        title: '学员姓名',
        require: true
    },
    {
        title: '上课方式'
    },
    {
        title: '问题详情'
    },
    {
        title: '图片'
    },
    {
        title: '任务时段'
    },
    {
        title: '所属导师'
    },
    {
        title: '任务状态'
    },
    {
        title: '所属学管'
    },
    {
        title: '学员评价状态'
    },
    {
        title: '学员评价时间'
    },
    {
        title: '项目'
    },
    {
        title: '团队'
    },
    {
        title: '科目'
    },
    {
        title: '预约周期'
    },
    {
        title: '任务提交时间'
    },
    {
        title: '处理完成时间'
    },
    {
        title: '完成方式'
    },
    {
        title: '备注'
    },
    {
        title: '服务总时长'
    },
    {
        title: '实际服务时长'
    },
    {
        title: '操作',
        require: true
    },

];
